
/**
* @fileOverview FancyDropDown module definition
* Last Modified: 02/06/2017

* Future Enhancements:
Keyboard Shortcuts:
page up: focus the first item in the previous page
page down: focus the first item in the next page
end: focus last item
home: focus first item
*/


(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('views/FancyDropDown',['require','jquery','lib/Util'],function (require) {
        var $ = require('jquery');
        var Util = require('lib/Util');

        $debug('FancyDropDown loaded... use ?debug=fancyDropDown for messages');
        $debug('Checking to see if this message comes through first', 'fancyDropDown');

        /**
         * This turns a select box into a fancy select box
         *
         * @class FancyDropDown
         * @param {jQuery} $element A reference to the containing DOM element
         * @constructor
         */
        var FancyDropDown = function ($element) {
            $debug('Initializing Fancy Dropdown for element:', 'fancyDropDown');
            $debug($element, 'fancyDropDown');
          
            /**
             * A reference to the original DOM element
             *
             * @default null
             * @property $element
             * @type {jQuery}
             * @public
             */
            this.$element = $($element);
          
            /**
             * A random ID to tie the fancy element to the original
             *
             * @default null
             * @property uniqueID
             * @type int
             * @public
             */
            this.uniqueID = Math.floor(Math.random() * 1000000000);
          
            /**
             * The fancy dropdown container DOM element
             *
             * @default null
             * @property $container
             * @type {jQuery}
             * @public
             */
            this.$container = $('<div id="js-fancyDropdown_' + this.uniqueID + '" class="MMM--fancyDropDiv"></div>');
          
            /**
             * The fancy heading container DOM element
             *
             * @default null
             * @property $headingContain
             * @type {jQuery}
             * @public
             */
            this.$headingContain = $('<div class="js-fancyDropAnchor MMM--fancyDropAnchor"></div>');
          
            /**
             * The fancy heading DOM element
             *
             * @default null
             * @property $heading
             * @type {jQuery}
             * @public
             */
            this.$heading = $('<span class="MMM--fancyDropLabel fancytxtTrncte"></div>');
          
            /**
             * The fancy heading icon DOM element
             *
             * @default null
             * @property $headingIcn
             * @type {jQuery}
             * @public
             */
            this.$headingIcn = $('<div class="msdsArrow MMM--icn MMM--icn_arrowDown MMM--icn_arrowUp"></div>');

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @property isEnabled
             * @type {bool}
             * @public
             */
            this.isEnabled = false;

            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         * Exits early if it is already initialized
         *
         * @method init
         * @returns {FancyDropDown}
         * @private
         */
        FancyDropDown.prototype.init = function () {
            this.setOptions()
				.setupHandlers()
                .build();

            return this;
        };

        /**
		 * This sets the options via data-options in the html markup. If
		 * the options aren't set it goes to the defaults.
		 *
		 * @method setOptions
		 * @returns {FancyDropDown}
		 * @private
		 */
        FancyDropDown.prototype.setOptions = function () {
            var options = this.$element.data().options;

            var defaults = {
                enabled: true,
                truncateTxt: 45,
                Dots: true,
                dropDownValues: '',
                countryValues: ''
            };

            this.settings = $.extend({}, defaults, options);    //merge defaults with data-options object
            $debug('\n\n******** fancyDropDown Options **********', 'fancyDropDown');
            $debug('     HTML data-options Settings: ' + $printObj(options), 'fancyDropDown');
            $debug('     Default Settings: ' + $printObj(defaults), 'fancyDropDown');
            $debug('     Combined Settings: ' + $printObj(this.settings), 'fancyDropDown');
            return this;
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * This creates event handlers and binds the scope
         * of the JS.
         *
         * @method setupHandlers
         * @returns {FancyDropDown}
         * @private
         */
        FancyDropDown.prototype.setupHandlers = function () {
            $debug('*** In setUpHandlers ***', 'fancyDropDown');
            var self = this;
            this.onClickHandler = this.onClick.bind(this);
            this.onChangeHandler = this.onChange.bind(this);
            this.onFocusinHandler = this.onFocusin.bind(this);
            this.onFocusoutHandler = this.onFocusout.bind(this);

            /**
             * function to update the selectbox and <ol> List on the fly with the dynamic
             * option created via trigger() event on domReady.
             *
             */
            $(self.$element).bind('updateOptions', function (newValues) {
                //convert the javascript arguments (which are not really array) into array
                var $arr = Array.prototype.slice.call(arguments, 1),
                    countOption = self.$element.find('option').length,
                    key,
                    value;

                //output msgs
                $debug('*** In updateOptions fn ***', 'fancyDropDown');
                $debug('number of options before adding new == ' + countOption, 'fancyDropDown');
                $debug('total objects === ' + $arr.length, 'fancyDropDown');
                $debug('First Obj === ' + $arr[0], 'fancyDropDown');
                $debug('Another testing message', 'fancyDropDown');

                // function to loop through array objects key, value pairs
                $.each($arr, function (idx, obj){
                    key = '';
                    value = '';
                    if(obj.key && obj.value){
                        key = obj.key;
                        value = obj.value;
                    } else{
                        $.each(obj, function(param, val){
                            key = param;
                            value = val;
                        });
                    }
                      
                    $debug('updateOptions KEY === ' + key + ' VALUE === ' + value, 'fancyDropDown');

                    //adding <option> to the original selectbox
                    $(self.$element).append($('<option></option>').attr('value', value).text(key));
                });
            });

            /**
             * function to remove and update the selectbox and <ol> List on the fly with the dynamic
             * option created via trigger() event on domReady.
             */
            $(self.$element).bind('removeOptions', function (newValues) {
                //convert the javascript arguments (which are not really array) into array
                var $arr = Array.prototype.slice.call(arguments, 1),
                    countOption = self.$element.find('option').length;

                //output msgs
                $debug('*** In removeOptions fn ***', 'fancyDropDown');
                $debug('number of options before removing new == ' + countOption, 'fancyDropDown');
                $debug('total objects === ' + $arr.length, 'fancyDropDown');
                $debug('First Obj Key === ' + $arr[0].key, 'fancyDropDown');

                // function to loop through array objects key, value pairs
                $.each($arr, function (idx, obj) {
                    $debug('removeOptions KEY === ' + obj.key + ' VALUE === ' + obj.value, 'fancyDropDown');

                    //removing <option> to the original selectbox
                    $(self.$element).find('option[value="' + obj.value + '"]').remove();
                });
              
                // Update the fancy header to match the new selection
                $(self.$heading).text($(self.$element).children('option:selected').text());
            });

            /**
            * function to update the selectbox selected element on the fly with the dynamic
            * option created via trigger() event on domReady.
            *
            */
            $(self.$element).bind('updateSelected', function (newValues) {

                //convert the javascript arguments (which are not really array) into array
                var $arr = Array.prototype.slice.call(arguments, 1),
                    countOption = self.$element.find('option').length;
              
                //checks to see if more than one object is being passed through
                if ($arr.length === 1) {
                    // function to loop through array objects key, value pairs
                    $.each($arr, function (idx, obj) {
                        //checks to see if the object being passed is contained in the select box
                        if ($(self.$element).children('option:contains(' + obj.key + ')').length > 0) {
                            //adds selected attribute to option if the obj.key matches that from object passed (original selectbox)
                            $(self.$element).find('option:contains(' + obj.key + ')').attr("selected", "selected");
                        } else {
                            $debug('The object key passed' + obj.key + ' does not match any values in the select box', 'fancyDropDown');
                        };
                    });
                } else {
                    $debug('total objects === ' + $arr.length + ' you are trying to pass to many objects. You may only have one option selected', 'fancyDropDown');
                };
              
                // Update heading to match selected option
                self.$heading.text(self.$element.find('option:selected').text());

            });


            /**
             * function to hide the selectbox and fancydropdowns List on the fly with the dynamic
             * option created via trigger() event on domReady.
             */
            $(self.$element).bind('hideDropdown', function (newValues) {
                //output msgs
                $debug('*** In hideDropdown fn ***', 'fancyDropDown');
                $debug('Fourth Message', 'fancyDropDown');

                //hide <select> selectbox
                $(self.$container).hide();
            });

            /**
             * function to hide the selectbox and fancydropdowns List on the fly with the dynamic
             * option created via trigger() event on domReady.
             */
            $(self.$element).bind('showDropdown', function (newValues) {
                //output msgs
                $debug('*** In showDropdown fn ***', 'fancyDropDown');

                //hide <select> selectbox
                $(self.$container).show();
            });

            /**
             * function to reset the selectbox and fancydropdowns List on the fly with the dynamic
             * resetDropdown via trigger() event on domReady.
             */
            $(self.$element).bind('resetDropdown', function (newValues) {

                $debug('*** In resetDropdown fn ***', 'fancyDropDown');

                //grab first item value <option> to the original selectbox
                var firstItem = $(self.$element).find('option:first'),
                    getFirstOptionVal = firstItem.text();

                $debug('getFirstOptionVal = ' + getFirstOptionVal, 'fancyDropDown');
                $debug('Your selected value is ' + $(self.$element).children('option:selected').val(), 'fancyDropDown');

                // set the original select box to default value or to 0
                $(self.$element).prop('selectedIndex', 0);

                $debug('Your selected value is after cancel ' + $(self.$element).children('option:selected').val(), 'fancyDropDown');
              
                // Update the fancy header to match the new selection
                $(self.$heading).text($(self.$element).children('option:selected').text());
            });

            return this;
        };

        /**
         * Performs measurements and applys any positioning style logic
         *
         * @method build
         * @returns {FancyDropDown}
         * @public
         */
        FancyDropDown.prototype.build = function () {
            $debug('*** In build ***', 'fancyDropDown');
          
            var self = this,
                selectedTxt = '';
          
            //calling dynamicValues on load
            self.dynamicValues();
            
            //calling countryList on load
            self.countryList();
            selectedTxt = this.$element.find('option:selected').text();

          
            // Remove hard-coded instances of MMM--isVisuallyHidden, this causes serious accessibility issues
            this.$element.removeClass('MMM--isVisuallyHidden');
          
            // Construct fancy dropdown using jQuery element templates
            this.$element.attr('data-id', 'js-fancyDropdown_' + this.uniqueID).addClass('MMM--isHiddenOverlay');
            this.$heading.text(self.truncateText(selectedTxt));
            this.$headingContain.append(this.$heading).append(this.$headingIcn);
            this.$container.append(this.$headingContain);
            this.$element.before(this.$container);
            this.$container.append(this.$element);
          
            if(self.$element.attr('disabled') === 'disabled'){
                self.disable();
            }
            else{
                self.enable();
            }
          
            return this;
        };

        /**
         * Enables the component
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {FancyDropDown}
         * @public
         */
        FancyDropDown.prototype.enable = function () {
            $debug('*** In enable ***', 'fancyDropDown');
            if (this.isEnabled) {
                return this;
            }
            this.isEnabled = true;
            this.$container.on('click', this.onClickHandler);   //click event for fancy select
            this.$element.on('change', this.onChangeHandler);
            this.$element.on('focusin', this.onFocusinHandler);
            this.$element.on('focusout', this.onFocusoutHandler);
          
            return this;
        };

        /**
         * Disables the component
         * Removes any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method disable
         * @returns {FancyDropDown}
         * @public
         */
        FancyDropDown.prototype.disable = function () {
            $debug('*** In disable ***', 'fancyDropDown');
            this.isEnabled = false;
            this.$container.off('click', this.onClickHandler);   //remove click event for fancy select
            this.$container.on('click', function () {
                return false;
            });   //add click event for fancy select to return false
            this.$container.addClass('MMM--isDisabled');
          
            return this;
        };

        //////////////////////////////////////////////////////////////////////////////////
        // EVENT HANDLERS AND UTILITY FUNCTIONS
        //
        // Place events here, use event handlers to access it
        //////////////////////////////////////////////////////////////////////////////////

        /**
         * onClick handler
         * When the select is clicked it should open the open the dropdown.
         *
         * @method onClick
         * @private
         */

        FancyDropDown.prototype.onClick = function (e, b) {
            $debug('*** In onClick ***', 'fancyDropDown');
            var self = this;

            // Simulate a click on the original select element - commenting out because of infinite looping (continuously calling this .onClick event)
            // self.$element.click();

            // Toggle the MMM--icn_arrowDown class because it overrides the MMM--icnArrowUp class
            self.$headingIcn.toggleClass('MMM--icn_arrowDown');
            
            // Keep the focus from focusin
            $(e.currentTarget).siblings('.js-fancyDropAnchor').addClass('MMM--isFocus');
        };

        /**
         * onChange handler
         * When the select changes value it should update the fancy heading
         *
         * @method onChange
         * @private
         */

        FancyDropDown.prototype.onChange = function (e, b) {
            $debug('*** In onChange ***', 'fancyDropDown');
            $debug('Selected element:', 'fancyDropDown');
            $debug($(e.currentTarget), 'fancyDropDown');
          
            var newText = $(e.currentTarget).find('option:selected').text(),
                newVal = $(e.currentTarget).val();
          
            this.updateHeading(newText, newVal);
        };

        /**
         * onFocusin handler
         * When the select is in focus the header should reflect this
         *
         * @method onFocusin
         * @private
         */

        FancyDropDown.prototype.onFocusin = function (e, b) {
            $debug('*** In onFucosin ***', 'fancyDropDown');
            $debug('Selected element:', 'fancyDropDown');
            $debug($(e.currentTarget), 'fancyDropDown');
          
            $(e.currentTarget).siblings('.js-fancyDropAnchor').addClass('MMM--isFocus');
        };

        /**
         * onFocusout handler
         * When the select is blurred (focusout) the header should reflect this
         *
         * @method onFocusout
         * @private
         */

        FancyDropDown.prototype.onFocusout = function (e, b) {
            $debug('*** In onFocusout ***', 'fancyDropDown');
            $debug('Selected element:', 'fancyDropDown');
            $debug($(e.currentTarget), 'fancyDropDown');
          
            $(e.currentTarget).siblings('.js-fancyDropAnchor').removeClass('MMM--isFocus');
            this.$headingIcn.toggleClass('MMM--icn_arrowDown', true);
        };

        /**
         * Updates the fancy dropdown heading to reflect the selected option
         *
         * @method updateHeading
         * @private
         */
        FancyDropDown.prototype.updateHeading = function (text, value) {
            $debug('*** In updateHeading ***', 'fancyDropDown');
          
            this.$heading.text(this.truncateText(text)).attr('data-value', value);
          
            return this;
        };

        /**
         * Truncates text inside the select menu option elements
         *
         * @method truncateText
         * @private
         */
        FancyDropDown.prototype.truncateText = function (str) {
            $debug('*** In truncateText ***', 'fancyDropDown');
            var self = this,
                truncatedString = str,
                truncateLength = self.settings.truncateTxt,
                Dotss = self.settings.Dots;

            if (str.length >= truncateLength) {

                if (Dotss) {
                    truncatedString = str.substring(0, truncateLength) + '...';
                } else {
                    truncatedString = str.substring(0, truncateLength);
                }
            }

            return truncatedString;
        };

        /**
         * Get the dynamic values keyword and add to the selectbox
         * The below scenario adds values for trhe %BrirthYear%
         * @method dynamicValues
         * @returns {FancyDropDown}
         * @public
         */
        FancyDropDown.prototype.dynamicValues = function () {
            $debug('*** In dynamicValues ***', 'fancyDropDown');
            $debug('*******New Comment****** ', 'fancyDropDown');
            var self = this,
                arrVal = '%BirthYear%',
                keyValSeperator = '$$',
                ddValues = self.settings.dropDownValues,
                ddVal = [],
                splitVal = [],
                newDate = new Date(),
                year = newDate.getFullYear(),
                overEighteen,
                underHundred,
                i;

            if (ddVal.length !== -1) {

                $debug('Starting setup for Birthyear ', 'fancyDropDown');

                ddVal = ddValues.split('|');

                $debug('this is ddVal after split ' + ddVal, 'fancyDropDown');

                $.each(ddVal, function (key, value) {
                    $debug('Adding all options key: ' + key + ' value: ' + value, 'fancyDropDown');
                    $debug('Checking to see if this message comes through', 'fancyDropDown');

                    //Check for BirthYear, condition show 1915 till 1997 for rU-04-subscribe
                    if (value.indexOf(arrVal) !== -1) {
                        overEighteen = year - 18;
                        underHundred = year - 100;
                        $debug('************* This year minus 100 years = ' + underHundred, 'fancyDropDown');
                        $debug('************* This year minus 18 years = ' + overEighteen, 'fancyDropDown');
                        for (i = year; i >= underHundred; i--) {
                            if (i <= overEighteen) {
                                self.$element.append($('<option />').val(i).html(i));
                                self.$element.sort(function (a, b) {
                                    return b - a;
                                });
                                self.$element.children('option[value="%BirthYear%"]').remove();
                            }
                        }
                    }
                    if (value.indexOf(keyValSeperator) !== -1) { //$.isin Array
                        //splitVal = value.replace(keyValSeperator, '');
                        splitVal = value.split(keyValSeperator);
                        $debug('splitVal VALUE === ' + splitVal, 'fancyDropDown');

                        //self.$element.append($('<option />').val(splitVal).html(splitVal));
                        self.$element.append($('<option></option>').attr('value', splitVal[1]).text(splitVal[0]));
                        self.$element.children('option[value="' + value + '"]').remove();
                    }
                });
            }
        };

         FancyDropDown.prototype.countryList = function () {
            var self = this,
                countryArray = [],
                arrVal = '%Country%',
                keyValSeperator = '$$',
                cValues = self.settings.countryValues,
                cVal = [],
                splitVal = [],
                newVal = [];

                countryArray = { 
                    'Afghanistan' : 'Afghanistan',
                    'Aland Islands' : 'Aland Islands',
                    'Albania' : 'Albania',
                    'Algeria' : 'Algeria',
                    'Andorra' : 'Andorra',
                    'Angola' : 'Angola',
                    'Anguilla' : 'Anguilla',
                    'Antarctica' : 'Antarctica',
                    'Antigua and Barbuda' : 'Antigua and Barbuda',
                    'Argentina' : 'Argentina',
                    'Armenia' : 'Armenia',
                    'Aruba' : 'Aruba',
                    'Australia' : 'Australia',
                    'Austria' : 'Austria',
                    'Azerbaijan' : 'Azerbaijan',
                    'Bahamas' : 'Bahamas',
                    'Bahrain' : 'Bahrain',
                    'Bangladesh' : 'Bangladesh',
                    'Barbados' : 'Barbados',
                    'Belarus' : 'Belarus',
                    'Belgium' : 'Belgium',
                    'Belize' : 'Belize',
                    'Benin' : 'Benin',
                    'Bermuda' : 'Bermuda',
                    'Bhutan' : 'Bhutan',
                    'Bolivia' : 'Bolivia',
                    'Bonaire, Sint Eustatius and Saba' : 'Bonaire, Sint Eustatius and Saba',
                    'Bosnia and Herzegovina' : 'Bosnia and Herzegovina',
                    'Botswana' : 'Botswana',
                    'Bouvet Island' : 'Bouvet Island',
                    'Brazil' : 'Brazil',
                    'British Indian Ocean Territory' : 'British Indian Ocean Territory',
                    'Brunei Darussalam' : 'Brunei Darussalam',
                    'Bulgaria' : 'Bulgaria',
                    'Burkina Faso' : 'Burkina Faso',
                    'Burundi' : 'Burundi',
                    'Cambodia' : 'Cambodia',
                    'Cameroon' : 'Cameroon',
                    'Canada' : 'Canada',
                    'Cape Verde' : 'Cape Verde',
                    'Cayman Islands' : 'Cayman Islands',
                    'Central African Republic' : 'Central African Republic',
                    'Chad' : 'Chad',
                    'Chile' : 'Chile',
                    'China' : 'China',
                    'Christmas Island' : 'Christmas Island',
                    'Cocos (Keeling) Islands' : 'Cocos (Keeling) Islands',
                    'Colombia' : 'Colombia',
                    'Comoros' : 'Comoros',
                    'Congo' : 'Congo',
                    'Congo, the Democratic Republic of the' : 'Congo, the Democratic Republic of the',
                    'Cook Islands' : 'Cook Islands',
                    'Costa Rica' : 'Costa Rica',
                    'Croatia' : 'Croatia',
                    'Cuba' : 'Cuba',
                    'Curaçao' : 'Curaçao',
                    'Cyprus' : 'Cyprus',
                    'Czech Republic' : 'Czech Republic',
                    'Denmark' : 'Denmark',
                    'Djibouti' : 'Djibouti',
                    'Dominica' : 'Dominica',
                    'Dominican Republic' : 'Dominican Republic',
                    'Dutch Antilles' : 'Dutch Antilles',
                    'Ecuador' : 'Ecuador',
                    'Egypt' : 'Egypt',
                    'El Salvador' : 'El Salvador',
                    'Equatorial Guinea' : 'Equatorial Guinea',
                    'Eritrea' : 'Eritrea',
                    'Estonia' : 'Estonia',
                    'Ethiopia' : 'Ethiopia',
                    'Falkland Islands (Malvinas)' : 'Falkland Islands (Malvinas)',
                    'Faroe Islands' : 'Faroe Islands',
                    'Fiji' : 'Fiji',
                    'Finland' : 'Finland',
                    'France' : 'France',
                    'French Guiana' : 'French Guiana',
                    'French Polynesia' : 'French Polynesia',
                    'French Southern Territories' : 'French Southern Territories',
                    'Gabon' : 'Gabon',
                    'Gambia' : 'Gambia',
                    'Georgia' : 'Georgia',
                    'Germany' : 'Germany',
                    'Ghana' : 'Ghana',
                    'Gibraltar' : 'Gibraltar',
                    'Greece' : 'Greece',
                    'Greenland' : 'Greenland',
                    'Grenada' : 'Grenada',
                    'Guadeloupe' : 'Guadeloupe',
                    'Guam' : 'Guam',
                    'Guatemala' : 'Guatemala',
                    'Guernsey' : 'Guernsey',
                    'Guinea' : 'Guinea',
                    'Guinea-Bissau' : 'Guinea-Bissau',
                    'Guyana' : 'Guyana',
                    'Haiti' : 'Haiti',
                    'Heard Island and McDonald Islands' : 'Heard Island and McDonald Islands',
                    'Holy See (Vatican City State)' : 'Holy See (Vatican City State)',
                    'Honduras' : 'Honduras',
                    'Hong Kong' : 'Hong Kong',
                    'Hungary' : 'Hungary',
                    'Iceland' : 'Iceland',
                    'India' : 'India',
                    'Indonesia' : 'Indonesia',
                    'Iran, Islamic Republic of' : 'Iran, Islamic Republic of',
                    'Iraq' : 'Iraq',
                    'Ireland' : 'Ireland',
                    'Isle of Man' : 'Isle of Man',
                    'Israel' : 'Israel',
                    'Italy' : 'Italy',
                    'Ivory Coast' : 'Ivory Coast',
                    'Jamaica' : 'Jamaica',
                    'Japan' : 'Japan',
                    'Jersey' : 'Jersey',
                    'Jordan' : 'Jordan',
                    'Kazakhstan' : 'Kazakhstan',
                    'Kenya' : 'Kenya',
                    'Kiribati' : 'Kiribati',
                    'Korea - Republic of' : 'Korea - Republic of',
                    'Kosovo' : 'Kosovo',
                    'Kuwait' : 'Kuwait',
                    'Kyrgyzstan' : 'Kyrgyzstan',
                    'Lao People\'s Democratic Republic' : 'Lao People\'s Democratic Republic',
                    'Latvia' : 'Latvia',
                    'Lebanon' : 'Lebanon',
                    'Lesotho' : 'Lesotho',
                    'Liberia' : 'Liberia',
                    'Libyan Arab Jamahiriya' : 'Libyan Arab Jamahiriya',
                    'Liechtenstein' : 'Liechtenstein',
                    'Lithuania' : 'Lithuania',
                    'Luxembourg' : 'Luxembourg',
                    'Macao' : 'Macao',
                    'Macedonia, the former Yugoslav Republic of' : 'Macedonia, the former Yugoslav Republic of',
                    'Madagascar' : 'Madagascar',
                    'Malawi' : 'Malawi',
                    'Malaysia' : 'Malaysia',
                    'Maldives' : 'Maldives',
                    'Mali' : 'Mali',
                    'Malta' : 'Malta',
                    'Marshall Islands' : 'Marshall Islands',
                    'Martinique' : 'Martinique',
                    'Mauritania' : 'Mauritania',
                    'Mauritius' : 'Mauritius',
                    'Mayotte' : 'Mayotte',
                    'Mexico' : 'Mexico',
                    'Micronesia' : 'Micronesia',
                    'Moldova, Republic of' : 'Moldova, Republic of',
                    'Monaco' : 'Monaco',
                    'Mongolia' : 'Mongolia',
                    'Montenegro' : 'Montenegro',
                    'Montserrat' : 'Montserrat',
                    'Morocco' : 'Morocco',
                    'Mozambique' : 'Mozambique',
                    'Myanmar' : 'Myanmar',
                    'Namibia' : 'Namibia',
                    'Nauru' : 'Nauru',
                    'Nepal' : 'Nepal',
                    'Netherlands' : 'Netherlands',
                    'New Caledonia' : 'New Caledonia',
                    'New Zealand' : 'New Zealand',
                    'Nicaragua' : 'Nicaragua',
                    'Niger' : 'Niger',
                    'Nigeria' : 'Nigeria',
                    'Niue' : 'Niue',
                    'Norfolk Island' : 'Norfolk Island',
                    'North Korea' : 'North Korea',
                    'Northern Mariana Islands' : 'Northern Mariana Islands',
                    'Norway' : 'Norway',
                    'Oman' : 'Oman',
                    'Pakistan' : 'Pakistan',
                    'Palau' : 'Palau',
                    'Palestine' : 'Palestine',
                    'Panama' : 'Panama',
                    'Papua New Guinea' : 'Papua New Guinea',
                    'Paraguay' : 'Paraguay',
                    'Peru' : 'Peru',
                    'Philippines' : 'Philippines',
                    'Pitcairn' : 'Pitcairn',
                    'Poland' : 'Poland',
                    'Portugal' : 'Portugal',
                    'Puerto Rico' : 'Puerto Rico',
                    'Qatar' : 'Qatar',
                    'Reunion' : 'Reunion',
                    'Romania' : 'Romania',
                    'Russian Federation' : 'Russian Federation',
                    'Rwanda' : 'Rwanda',
                    'Saint Barthélemy' : 'Saint Barthélemy',
                    'Saint Helena, Ascension and Tristan da Cunha' : 'Saint Helena, Ascension and Tristan da Cunha',
                    'Saint Kitts and Nevis' : 'Saint Kitts and Nevis',
                    'Saint Lucia' : 'Saint Lucia',
                    'Saint Martin' : 'Saint Martin',
                    'Saint Pierre and Miquelon' : 'Saint Pierre and Miquelon',
                    'Saint Vincent and the Grenadines' : 'Saint Vincent and the Grenadines',
                    'Samoa' : 'Samoa',
                    'Samoa, American' : 'Samoa, American',
                    'San Marino' : 'San Marino',
                    'Sao Tome and Principe' : 'Sao Tome and Principe',
                    'Saudi Arabia' : 'Saudi Arabia',
                    'Senegal' : 'Senegal',
                    'Serbia' : 'Serbia',
                    'Seychelles' : 'Seychelles',
                    'Sierra Leone' : 'Sierra Leone',
                    'Singapore' : 'Singapore',
                    'Sint Maarten' : 'Sint Maarten',
                    'Slovakia' : 'Slovakia',
                    'Slovenia' : 'Slovenia',
                    'Solomon Islands' : 'Solomon Islands',
                    'Somalia' : 'Somalia',
                    'South Africa' : 'South Africa',
                    'South Georgia and the South Sandwich Islands' : 'South Georgia and the South Sandwich Islands',
                    'South Sudan' : 'South Sudan',
                    'Spain' : 'Spain',
                    'Sri Lanka' : 'Sri Lanka',
                    'Sudan' : 'Sudan',
                    'Suriname' : 'Suriname',
                    'Svalbard and Jan Mayen' : 'Svalbard and Jan Mayen',
                    'Swaziland' : 'Swaziland',
                    'Sweden' : 'Sweden',
                    'Switzerland' : 'Switzerland',
                    'Syrian Arab Republic' : 'Syrian Arab Republic',
                    'Taiwan' : 'Taiwan',
                    'Tajikistan' : 'Tajikistan',
                    'Tanzania, United Republic of' : 'Tanzania, United Republic of',
                    'Thailand' : 'Thailand',
                    'Timor-Leste' : 'Timor-Leste',
                    'Togo' : 'Togo',
                    'Tokelau' : 'Tokelau',
                    'Tonga' : 'Tonga',
                    'Trinidad and Tobago' : 'Trinidad and Tobago',
                    'Tunisia' : 'Tunisia',
                    'Turkey' : 'Turkey',
                    'Turkmenistan' : 'Turkmenistan',
                    'Turks and Caicos Islands' : 'Turks and Caicos Islands',
                    'Tuvalu' : 'Tuvalu',
                    'Uganda' : 'Uganda',
                    'Ukraine' : 'Ukraine',
                    'United Arab Emirates' : 'United Arab Emirates',
                    'United Kingdom' : 'United Kingdom',
                    'United States' : 'United States',
                    'United States Minor Outlying Islands' : 'United States Minor Outlying Islands',
                    'Uruguay' : 'Uruguay',
                    'Uzbekistan' : 'Uzbekistan',
                    'Vanuatu' : 'Vanuatu',
                    'Venezuela' : 'Venezuela',
                    'Vietnam' : 'Vietnam',
                    'Virgin Islands, British' : 'Virgin Islands, British',
                    'Virgin Islands, US' : 'Virgin Islands, US',
                    'Wallis and Futuna' : 'Wallis and Futuna',
                    'Western Sahara' : 'Western Sahara',
                    'Yemen' : 'Yemen',
                    'Zambia' : 'Zambia',
                    'Zimbabwe' : 'Zimbabwe'
                    }
                
                if (cVal.length !== -1) {
                $debug('Starting setup for Country List: ', 'fancyDropDown');

                        cVal = cValues.split('|');
                        $debug('this is cVal after split ' + cVal, 'fancyDropDown');

                            $.each(cVal, function (key, value) {
                                $debug('Adding all options key: ' + key + ' value: ' + value, 'fancyDropDown');
                                $debug('Checking to see if this message comes through', 'fancyDropDown');
                                
                                if (value.indexOf(arrVal) !== -1) {
                                  $debug('Matching Split value test confirmed', 'fancyDropDown');

                                        $('.js-countryDropdown').append($('<option></option>').attr('value', value).text(value));
                                        $('.js-countryDropdown').children('option[value="%Country%"]').remove();

                                            $.each(countryArray, function(key, value) {   
                                            $('.js-countryDropdown').append($("<option></option>").attr("value",key).text(value)); 
                                            });

                                }
                                
                                if (value.indexOf(keyValSeperator) !== -1) { //$.isin Array
                                    splitVal = value.split(keyValSeperator);
                                    $debug('splitVal VALUE === ' + splitVal, 'fancyDropDown');

                                    self.$element.append($('<option></option>').attr('value', splitVal[1]).text(splitVal[0]));
                                }

                            });


              }
            };
         
                         
        return FancyDropDown;
    });

}(MMMRequire));
